/**
 * A permit-type filter chip, shared by the Parkers roster and the Permits list.
 *
 * ONE component on purpose: both screens filter the same buckets, and a chip
 * that looks or behaves differently between them reads as a different control
 * doing a different thing. The count is part of the label rather than a
 * separate badge — "Vendor 2" is one fact.
 */
import { pillRadius } from '../ui'

export function TypeChip({
  label, count, active, onClick,
}: {
  label: string
  count: number
  active: boolean
  onClick: () => void
}) {
  return (
    <button
      onClick={onClick}
      aria-pressed={active}
      style={{
        fontSize: 12, fontWeight: 700, padding: '5px 12px', borderRadius: pillRadius, cursor: 'pointer',
        fontFamily: 'inherit',
        background: active ? '#7F3F98' : '#fff',
        color: active ? '#fff' : 'var(--color-gray-700)',
        border: `1.5px solid ${active ? '#7F3F98' : 'var(--color-gray-300)'}`,
      }}
    >
      {label} {count}
    </button>
  )
}
